export default "/_next/static/images/brand-magic-transition-28e920ec51089a19eb22a986e4db14dc.svg";